import { Box, IconButton, Typography } from '@material-ui/core'
import { styled } from '@material-ui/core/styles'

import { TrackButton } from 'artkive/components/Tracker'
import { BREAKPOINTS } from 'artkive/utils/constants'

export const BackgroundWrapper = styled(Box)(({ theme }) => ({
  background: 'linear-gradient(0deg, rgba(255,242,209,1) calc(50% - 68px), rgba(227,242,253,1) calc(50% - 68px))',
  [theme.breakpoints.down('sm')]: {
    background: 'unset',
  },
}))

export const ArrowButton = styled(IconButton)({
  width: 45,
  height: 45,
  padding: 0,
  zIndex: 2,
  position: 'absolute',
  top: 'calc(50% - 30px)', // 30px it's a half height of the icon height
})

export const LeftArrowButton = styled(ArrowButton)({
  left: '-70px',
})

export const RightArrowButton = styled(ArrowButton)({
  right: '-70px',
})

export const CardsWrapper = styled(Box)(({ theme }) => ({
  position: 'relative',
  minHeight: '400px',
  gap: '40px',
  display: 'flex',
  flexDirection: 'column',
  [theme.breakpoints.up('md')]: {
    flexDirection: 'row',
  },
}))

export const Card = styled(Box)(({ theme }) => ({
  boxShadow: theme.customShadows[5],
  backgroundColor: theme.colors.white,
  borderRadius: '8px',
  position: 'relative',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'row',
  zIndex: 1,
  overflow: 'hidden',
  [theme.breakpoints.up('md')]: {
    position: 'absolute',
    height: '400px',
    width: '100%',
  },
}))

export const Container = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '40px',
  [theme.breakpoints.up('md')]: {
    position: 'relative',
    display: 'block',
    margin: '0 100px',
  },
  [theme.breakpoints.up(BREAKPOINTS.lg)]: {
    margin: '0 64px',
  },
  [theme.breakpoints.up(BREAKPOINTS.xl)]: {
    margin: '0 auto',
  },
}))

const imageStyles = (theme) => ({
  objectFit: 'contain',
  height: '100%',
  [theme.breakpoints.up('md')]: {
    width: '380px',
    height: '88%',
  },
  [theme.breakpoints.up('lg')]: {
    width: '500px',
  },
})

export const Image = styled('img')(({ theme }) => ({
  ...imageStyles(theme),
}))

export const MosaicsImage = styled('img')(({ theme }) => ({
  ...imageStyles(theme),
  height: '90%',
  paddingTop: '18px',
  paddingLeft: '22px',
  [theme.breakpoints.up('md')]: {
    height: '80%',
    paddingTop: '24px',
    paddingLeft: '48px',
  },
}))

export const Content = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  paddingLeft: '16px',
  paddingRight: '16px',
  paddingTop: '32px',
  paddingBottom: '32px',
  [theme.breakpoints.up('md')]: {
    position: 'relative',
    padding: 0,
    maxWidth: '400px',
    marginLeft: '32px',
    marginRight: '32px',
  },
  [theme.breakpoints.up(1080)]: {
    marginLeft: '64px',
    marginRight: '64px',
  },
  [theme.breakpoints.up(1360)]: {
    marginLeft: '100px',
    marginRight: '100px',
  },
  [theme.breakpoints.down('sm')]: {
    paddingBottom: '48px',
  },
}))

export const ContentBox = styled(Box)(({ theme }) => ({
  position: 'relative',
  textAlign: 'center',
  width: '100%',
  [theme.breakpoints.up('md')]: {
    textAlign: 'left',
    width: '100%',
    display: 'flex',
  },
}))

export const LinesImage = styled('img')(({ theme }) => ({
  position: 'absolute',
  width: 98,
  right: 0,
  bottom: 82,
  zIndex: 1,
  [theme.breakpoints.down(1080)]: {
    right: -16,
  },
}))

export const SectionTitle = styled(Typography)({
  textAlign: 'center',
})

export const StyledTrackButton = styled(TrackButton)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    maxWidth: '220px',
    padding: '12px 24px',
  },
}))

export const ImageContainer = styled('div')(({ theme, bgColor }) => ({
  position: 'relative',
  backgroundColor: bgColor,
  maxHeight: '300px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  [theme.breakpoints.up('sm')]: {
    maxHeight: '400px',
  },
}))

export const ImageWrapper = styled('div')(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '300px',
  [theme.breakpoints.up('sm')]: {
    height: '400px',
  },
}))

const badgeStyles = (theme) => ({
  position: 'absolute',
  top: '12px',
  right: '-48px',
  width: '128px',
  zIndex: 1,
  '& img': {
    width: '100%',
    height: '100%',
  },
  [theme.breakpoints.up('md')]: {
    top: '12px',
    right: 'auto',
    left: '20px',
    width: '140px',
  },
})

export const BadgeWrapper = styled('div')(({ theme }) => ({
  ...badgeStyles(theme),
}))

export const MosaicsBadgeWrapper = styled('div')(({ theme }) => ({
  ...badgeStyles(theme),
  right: '-24px',
}))
